import React from 'react';
import PropTypes from 'prop-types';

class Accordion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.isOpen,
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState(state => ({
            isOpen: !state.isOpen,
        }));
    }

    render() {
        return this.props.children({
            isOpen: this.state.isOpen,
            onToggle: this.handleToggle,
        });
    }
}

Accordion.defaultProps = {
    isOpen: false,
};

Accordion.propTypes = {
    children: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Accordion.jsx